import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { interval, Subscription } from 'rxjs';

@Component({
  selector: "app-information-dialog",
  templateUrl: "./thx-logout-dialog.component.html",
  styleUrls: ["./thx-logout-dialog.component.scss"]
})
export class ThxLogoutDialogComponent implements OnInit, OnDestroy {

  constructor(public dialogRef: MatDialogRef<ThxLogoutDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  reloadTime: number = 10;

  reloading: boolean = false;

  reloadSubscription: Subscription;

  ngOnInit() {
    this.reloadSubscription = interval(1000).subscribe(() => {
      if (this.reloadTime > 0) {
        this.reloadTime--;
        if (this.reloadTime == 0) {
          this.reloading = true;
          window.location.href = "/"
        }
      }

    });
  }

  ngOnDestroy(): void {
    this.reloadSubscription.unsubscribe();
  }


  closeAction() {
    this.reloading = true;
    window.location.href = "/"
  }
}
